/**
 * Turf.js helper to create a point
 * @param {Array} coordinates [longitude, latitude]
 * @returns {Object} GeoJSON Point Feature
 */
export function point(coordinates) {
  return {
    type: "Feature",
    properties: {},
    geometry: {
      type: "Point",
      coordinates: coordinates,
    },
  };
}
